import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, Input, HostListener } from '@angular/core';
import { TranslateService } from "ng2-translate";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from '../_services/user.service';
import { Subscription, Observable } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { NgbTabset, NgbTab } from '@ng-bootstrap/ng-bootstrap';
import { AngularFirestore } from 'angularfire2/firestore';
import { MetaService } from 'ng2-meta';
import { ScrollService } from '../_services/scroll.service';
import { ApiService } from '../_services/api.service';

@Component({
  selector: "app-brand-profile",
  templateUrl: "./brand-profile.component.html",
  styleUrls: ["./brand-profile.component.css"]
})
export class BrandProfileComponent implements OnInit, AfterViewInit, OnDestroy {

  private subscription: Subscription = new Subscription();
  private sub = new Subscription();
  brandName: string;
  brandRate: Observable<any[]>;
  brand: any;
  uniqueName: string;
  userId = this.userService.getUid();
  user: any;
  brandCategories: Observable<any[]>;
  model: any;
  averageRate: any;
  categoryButtonText: any;
  peopleCount: any;
  mobileQuery: any;
  hasCatPoint = false;
  companyBannerImage: any;
  companyBannerImage2: any;
  bannerLinks: any;
  brandId: string;
  name: string;
  seoBrand;
  seoBrandNew: Observable<any[]>;
  visible: any;
  activeId: any;
  keywords: any = [];
  order = 'order';

  name2: string;
  innerWidth: number;
  private _mobileQueryListener: () => void;
  @Input() username;
  @ViewChild('tabset') tabset: NgbTabset;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private afs: AngularFirestore,
    private userService: UserService,
    private apiSerw: ApiService,
    public translate: TranslateService,
    private metaService: MetaService,
    private scrollService: ScrollService,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef,
    private cdr: ChangeDetectorRef
  ) {



    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
    this.mobileQuery = this.media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
    this.sub.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  ngOnInit() {
    const url = decodeURIComponent(this.router.url);

    window.dispatchEvent(new Event('resize'));

    this.subscription.add(this.route.params.subscribe(params => {
      const url = decodeURIComponent(this.router.url);
      if (url.indexOf("#") != -1) {
        this.brandName = params["uniqueName"].split("#")[0];
        this.uniqueName = (url.split("#")[0] || url.split("#")[0].split("/")[2]) + "/hashtags/" + url.split("#")[1];
        this.metaService.setTitle("bigadvice'ta" + ' ' + this.brandName.charAt(0).toUpperCase() + this.brandName.slice(1).toLowerCase() + ' ' + '#' + url.split('#')[1] + ' ' +
          "Etiketli Paylaşımlar | bigadvice.com");
        this.metaService.setTag('description', this.brandName.charAt(0).toUpperCase() + this.brandName.slice(1).toLowerCase() + ' ' + '#' + url.split('#')[1] + ' ' +
          'etiketiyle yapılan paylaşımların tamamını okuyabilir, sen de' + ' ' + this.brandName.charAt(0).toUpperCase() + this.brandName.slice(1).toLowerCase() + ' ' + "ile ilgili deneyimlerini özgürce paylaşabilirsin.");
        this.cd.markForCheck();


      } else {
        this.brandName = this.uniqueName = params["uniqueName"];

        this.cd.markForCheck();

      }
      // this.apiSerw.sqlPost('corporate/keywordBrandProcedure',
      //   { uniqueName: this.brandName }).map(res => res.json()).toPromise().then(data => {
      //     data.forEach(a => {
      //       this.keywords.push({ keyword: a.keyword });
      //     });
      //   });



      this.afs.collection('brands').ref.where('uniqueName', '==', this.brandName).get().then(snap => {
        if (!snap.empty) {
          this.brandId = snap.docs[0].id;
          this.brand = snap.docs[0].data();
          this.peopleCount = snap.docs[0].data().peopleCount;

          if (url.indexOf('#') === -1) {
            this.metaService.setTitle(snap.docs[0].data().name + ' ' + '-' + ' ' +
              'Kullanıcı Yorumları, Müşteri Şikayet, Görüş ve Önerileri' + ' | ' + 'bigadvice.com');
            this.metaService.setTag('description', snap.docs[0].data().name + ' ' +
              "müşterileri bigavice'ta buluşuyor... " + snap.docs[0].data().name + ' ' +
              " müşteri şikayet, öneri, tavsiye paylaşımlarını okuyabilir, burada sen de deneyimlerini özgürce paylaşabilirsin.");
          }
          if (snap.docs[0].data().bannerImage) {
            this.companyBannerImage = snap.docs[0].data().bannerImage;
          }
          if (snap.docs[0].data().bannerImage3) {
            this.companyBannerImage2 = snap.docs[0].data().bannerImage3;
          }
          if (snap.docs[0].data().bannerLink) {
            this.bannerLinks = snap.docs[0].data().bannerLink;
          }

        }

        this.cd.markForCheck();
      }).then(() => {
        this.afs.collection('brands').doc(this.brandId).collection('categories').ref.onSnapshot(data1 => {

          let array: any[] = [];
          data1.docs.map(snap1 => {


            array.push({ name: snap1.data().name, average: snap1.data().total / snap1.data().peopleCount });
            let temp = 0;
            let name: any;
            for (let i = 0; i < array.length; i++) {
              if (temp < array[i].average) {
                temp = array[i].average;
                name = array[i].name;
              }
            }
            console.log(array)
            console.log(array.length, name)

            if (array.length > 1 && name) {

              this.afs.collection('brands').doc(this.brandId).collection('categories').ref.where('name', '==', name).get().then(criteria => {

                criteria.docs.map(cri => {
                  if (cri.data().peopleCount) {

                    this.brandRate = cri.data().criterias;
                    console.log(this.brandRate)
                  }

                })

              })
              this.averageRate = temp;
              this.cd.markForCheck();

              this.categoryButtonText = name == 'Genel' ? 'Marka Puanı' : name;
            }
            else if (array.length === 1 && name) {
              console.log(name, 'guşsah')
              this.afs.collection('brands').doc(this.brandId).collection('categories').ref.where('name', '==', name).get().then(criteria => {
                criteria.docs.map(cri => {
                  if (cri.data().total) {

                    this.brandRate = cri.data().criterias;
                  }
                })
              })
              name = array[0].name;
              this.averageRate = array[0].average;
              this.cd.markForCheck();
              this.categoryButtonText = name == 'Genel' ? 'Marka Puanı' : name;

            }
            else if (array.length === 1 && !name) {
              name = 'Genel';

              this.averageRate = array[0].average;
              console.log(this.brandId)
              this.afs.collection('brands').doc(this.brandId).collection('categories')
                .ref.where('name', '==', 'Genel').get().then(criteria => {
                  criteria.docs.map(cri => {
                    this.brandRate = cri.data().criterias;
                    this.cd.markForCheck();
                  });
                });

              this.cd.markForCheck();
              this.categoryButtonText = name == 'Genel' ? 'Marka Puanı' : name;

            }


            if (array.length === 0) {

              this.categoryButtonText = 'Marka Puanı';
            }
          })
        })
      }).then(() => {

        this.brandCategories = this.afs.collection('brands').doc(this.brandId).collection('categories').valueChanges();
      })

    }));
    this.sub = this.scrollService.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 620) {
        this.visible = true;

      }
      else {
        this.visible = false;

      }
    })

    this.afs.collection('brands').ref.where('uniqueName', '==', this.brandName).get().then(brandID => {

      this.afs.collection('brands').doc(brandID.docs[0].id).collection('categories').ref.where('name', '==', 'Genel').get().then(snap => {
        if (snap.empty) {
          this.afs.collection('brands').doc(brandID.docs[0].id).collection('categories').add({ name: 'Genel' });
        }
      })
    })




  }

  choseCategory(string) {

    this.categoryButtonText = string == 'Genel' ? 'Marka Puanı' : string;

    this.afs.collection('brands').doc(this.brandId).collection('categories').ref.where('name', '==', string).get().then(x => {
      x.docs.map(criteria => {
        if (criteria.data().total) {
          this.brandRate = criteria.data().criterias;
          this.averageRate = criteria.data().total / criteria.data().peopleCount;
        }
      })
    })

    this.cd.markForCheck();
  }

  onTabChange($event) {

    this.activeId = $event.nextId;


    if (this.activeId === '0') {
      this.order = 'order';

    }
    if (this.activeId === '1') {
      this.order = 'valueOf_ModifyDate';
    }
    else if (this.activeId === 'followers' || this.activeId === 'products') {
      this.order = 'notValue';
    }

    this.cd.markForCheck();
  }

  ngAfterViewInit() {
    // this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/brand-profile/brand-profile.component.ts